module.exports = __webpack_public_path__ + "static/media/color5.b61b200a.svg";